var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--join"
  }, [_c('main', {
    staticClass: "main",
    attrs: {
      "role": "main"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', {
    staticClass: "join-title"
  }, [_vm._v("회원가입")]), _c('div', {
    staticClass: "join-container"
  }, [_c('div', {
    staticClass: "join-gate"
  }, [_c('div', {
    staticClass: "join-gate-box join-gate-box--personal"
  }, [_c('div', {
    staticClass: "join-gate-box__inner"
  }, [_c('i', {
    staticClass: "icon icon-general"
  }), _c('h2', [_vm._v("일반회원 가입")]), _c('v-btn', {
    staticClass: "mt-30 min-w-120px min-w-lg-140px",
    attrs: {
      "rounded": "",
      "color": "primary",
      "elevation": "0"
    },
    on: {
      "click": function click($event) {
        return _vm.submit(_vm.USER_TYPES.INDIVIDUAL);
      }
    }
  }, [_vm._v("가입하기")])], 1)]), _c('div', {
    staticClass: "join-gate-box join-gate-box--business"
  }, [_c('div', {
    staticClass: "join-gate-box__inner"
  }, [_c('i', {
    staticClass: "icon icon-business"
  }), _c('h2', [_vm._v("기업회원 가입")]), _c('v-btn', {
    staticClass: "mt-30 min-w-120px min-w-lg-140px",
    attrs: {
      "rounded": "",
      "color": "primary",
      "elevation": "0"
    },
    on: {
      "click": function click($event) {
        return _vm.submit(_vm.USER_TYPES.ORGANIZATION);
      }
    }
  }, [_vm._v("가입하기")])], 1)])])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }